import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import { FlyoutLangselectorComponent } from '../../flyout/flyout-langselector/flyout-langselector.component';
import { ContentCountryLanguage } from '../../model/content/contentCountryLanguage.model';
import { ContentDarkSite } from '../../model/content/contentDarkSite.model';
import {
  AlertAdvisoriesItem,
  ContentAlertAdvisories
} from '../../model/content/contentalertadvisories.model';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { TranslatedsitesLangService } from '../../services/translatedsites/translatedsiteslang.service';
import { CookieHelper } from '../cookie-helper';

@Component({
  selector: 'ngc-alert-advisories',
  templateUrl: './alert-advisories.component.html'
})
export class AlertAdvisoriesComponent implements OnDestroy, OnInit {
  @Output() alertAdvisoryClosed = new EventEmitter();
  public contentAlertAdvisories: ContentAlertAdvisories;
  public advisories: AlertAdvisoriesItem[] = [];
  public viewAllLabel;
  isEnabled = 'true';
  isDarkSiteEnabled = true;
  public darkSiteThemeContent: ContentDarkSite;
  contentHeaderFooterServiceSubscribe: Subscription;
  appliSubjectSubscribe: Subscription;
  showAlertAdvisoriesHeader = false;
  viewAllAlertAdvisories = true;
  setDefaultDisplay = false;
  private adAlertCookie: string;
  private unsubscribe: Subject<void> = new Subject();
  bsModalRef: BsModalRef;
  countryLanguageContent: ContentCountryLanguage;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentService: ContentHeaderFooterService,
    private appConfig: ApplicationConfig,
    private cookieHelper: CookieHelper,
    private modalService: BsModalService,
    private transSitesLangService: TranslatedsitesLangService,
    private srv: CommonService,
    private rend: Renderer2,
    private el: ElementRef,
    private loggingService: LoggingService
  ) {}

  public get adCookie() {
    return this.adAlertCookie;
  }

  ngOnInit() {
    this.transSitesLangService.setAlertFlag(true);
    if (this.transSitesLangService.propertyCheck()) {
      this.transSitesLangService.detectCurrentLanguage(this.el, this.rend);
      this.appliSubjectSubscribe =
        this.transSitesLangService._appliSubject.subscribe((appliSub) => {
          if (appliSub) {
            this.headerFooterCall();
          }
        });
    } else {
      this.headerFooterCall();
    }
    this.transSitesLangService.opencls.subscribe((open) => {
      if (open) {
        this.openCLS();
      }
    });
  }

  headerFooterCall() {
    const _self = this;
    if (this.appConfig.onBrowser && this.contentService.contentHeaderFooter) {
      this.contentHeaderFooterServiceSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                try {
                  let isAdvisoryMatch = false;
                  let selectedAdvisory;
                  this.contentAlertAdvisories = data.applicationadvisories;
                  this.darkSiteThemeContent = data.darkSite;
                  if (
                    data.applicationadvisories.defaultDisplay !== null &&
                    data.applicationadvisories.defaultDisplay !== undefined &&
                    data.applicationadvisories.defaultDisplay !== ''
                  ) {
                    this.setDefaultDisplay =
                      data.applicationadvisories.defaultDisplay.toLowerCase() ===
                      'false'
                        ? false
                        : true;
                  } else {
                    this.setDefaultDisplay = false;
                  }
                  if (this.contentAlertAdvisories) {
                    const applicationAdvisories =
                      this.contentAlertAdvisories.advisoriesList;
                    this.viewAllLabel =
                      this.contentAlertAdvisories.viewAllAdvisoriesLabel;
                    if (this.setDefaultDisplay) {
                      this.setCookieAlertValue(
                        this.contentAlertAdvisories.alertAdvisoriesLabel
                      );
                    }
                    if (
                      applicationAdvisories &&
                      applicationAdvisories !== undefined
                    ) {
                      const windowPath = window.location.pathname;
                      let contextPath = '';
                      let contextPathArray = [];
                      if (windowPath) {
                        contextPath = windowPath.split('/')[1];
                        contextPath = contextPath === '' ? 'home' : contextPath;
                      }
                      contextPathArray = windowPath.split('/');
                      if (
                        contextPathArray.length > 0 &&
                        contextPathArray.length === 3
                      ) {
                        let loc = '';
                        let lang = '';
                        let prefLang = '';
                        const prefLangVal =
                          _self.cookieHelper.getCookies('prefUI');
                        if (prefLangVal !== '' && prefLangVal !== null) {
                          prefLang = prefLangVal.split('-')[0].split('=')[1];
                          loc = contextPathArray[1];
                          lang = contextPathArray[2];
                          if (lang !== '' && lang !== null) {
                            if (lang === prefLang) {
                              contextPath = 'home';
                            }
                          }
                        }
                      }
                      const numberOfAdvisories = applicationAdvisories.length;
                      const advicoryCookie =
                        _self.cookieHelper.getCookies('ad_alert');
                      let isADNewCookierequired = false;
                      if (numberOfAdvisories > 0) {
                        applicationAdvisories.forEach(function (value) {
                          const apptype = value.apptype;
                          if (
                            contextPath &&
                            contextPath === apptype &&
                            value.key !== ''
                          ) {
                            if (!advicoryCookie) {
                              isAdvisoryMatch = true;
                              selectedAdvisory = value;
                              _self.adAlertCookie =
                                contextPath + ':' + value.key;
                            } else {
                              if (advicoryCookie.length > 0) {
                                const res = advicoryCookie.split('=');
                                const adCookieArray: any = [];
                                if (res && res.length > 0) {
                                  const appKey = res[1].split(',');
                                  if (appKey && appKey.length > 0) {
                                    for (let i = 0; i < appKey.length; i++) {
                                      if (appKey[i]) {
                                        const advisoryAppCookie =
                                          appKey[i].split(':');
                                        if (
                                          advisoryAppCookie &&
                                          advisoryAppCookie.length > 1
                                        ) {
                                          const adApp = advisoryAppCookie[0];
                                          const adAppKey = advisoryAppCookie[1];
                                          if (contextPath === adApp) {
                                            if (value.key === adAppKey) {
                                              adCookieArray.push(appKey[i]);
                                            } else {
                                              isADNewCookierequired = true;
                                              isAdvisoryMatch = true;
                                              selectedAdvisory = value;
                                              adCookieArray.push(
                                                contextPath + ':' + value.key
                                              );
                                            }
                                          } else {
                                            adCookieArray.push(appKey[i]);
                                          }
                                        }
                                      }
                                    }
                                    if (
                                      isADNewCookierequired &&
                                      adCookieArray
                                    ) {
                                      _self.adAlertCookie =
                                        adCookieArray.toString();
                                    }
                                  }
                                }
                              }
                            }
                          }
                        });
                      }
                    }
                  }
                  if (!isAdvisoryMatch) {
                    this.showAlertAdvisoriesHeader = this.setDefaultDisplay
                      ? this.setDefaultAdvisories()
                      : false;
                  } else {
                    this.advisories = selectedAdvisory;
                    if (
                      this.darkSiteThemeContent.isEnabled === this.isEnabled ||
                      this.appConfig.get('APP_DISABLE_LEGACY') === 'false'
                    ) {
                      this.showAlertAdvisoriesHeader = false;
                    } else {
                      this.showAlertAdvisoriesHeader = true;
                    }
                  }
                } catch (e) {
                  this.loggingService.log('Caught Error: ' + e);
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  setCookieAlertValue(alertAdvisoriesLabel) {
    const windowPath = window.location.pathname;
    let contextPath = '';
    if (windowPath) {
      contextPath = windowPath.split('/')[1];
      contextPath = contextPath === '' ? 'home' : contextPath;
    }
    this.adAlertCookie = contextPath + ':' + alertAdvisoriesLabel;
  }

  setDefaultAdvisories() {
    const _self = this;
    const advicoryCookie = _self.cookieHelper.getCookies('ad_alert');
    if (!advicoryCookie) {
      _self.adAlertCookie = this.contentAlertAdvisories.alertAdvisoriesLabel;
      return true;
    } else {
      // Add a code to check if cookie is present and cookie value is
      // same as of this.contentAlertAdvisories.alertAdvisoriesLabel then retrun false else true
      const splitAdvicoryCookie = advicoryCookie.split('=');
      // let showAlert = (splitAdvicoryCookie[1] === (_self.adAlertCookie).replace(/\s/g, '')) ? false : true;
      const showAlert =
        _self.adAlertCookie
          .replace(/\s/g, '')
          .indexOf(splitAdvicoryCookie[1]) !== -1
          ? false
          : true;
      return showAlert;
    }
  }

  openCLS() {
    if (isPlatformBrowser(this.platformId)) {
      const bodyScroll = document.documentElement.scrollTop;
      let obj;
      obj = Object.assign({}, this.appConfig, { class: 'lang-modal' });
      this.bsModalRef = this.modalService.show(
        FlyoutLangselectorComponent,
        obj
      );
      // this.animateCLSModal();
      this.bsModalRef.content.countryLanguageContent =
        this.countryLanguageContent;
      this.bsModalRef.content.dialog.nativeElement.focus();
      const htmlRoot = document.getElementsByTagName('html')[0];
      if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
        htmlRoot.className += ' no-scroll';
      }
      this.srv.dragModalContainers(this.el, this.rend);
      document.documentElement.scrollTop = bodyScroll;
      this.srv.focusModalContainers(this.el, this.rend);
      this.headerFooterCall();
    }
  }

  close() {
    this.alertAdvisoryClosed.emit();
    this.showAlertAdvisoriesHeader = false;
    this.cookieHelper.setCookies('ad_alert', this.adAlertCookie);
  }

  ngOnDestroy() {
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.appliSubjectSubscribe) {
      this.appliSubjectSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
